import { initializeApp, type FirebaseOptions } from "firebase/app";
import {
	GoogleAuthProvider,
	createUserWithEmailAndPassword,
	getAuth,
	sendPasswordResetEmail,
	signInWithEmailAndPassword,
	signInWithPopup,
	signOut,
	type User,
	type UserCredential,
} from "firebase/auth";
import {
	addDoc,
	collection,
	getDocs,
	getFirestore,
	query,
	where,
} from "firebase/firestore";

const firebaseConfig: FirebaseOptions = {
	apiKey:
		process.env.REACT_APP_FIREBASE_API_KEY ??
		"AIzaSyCy0UofVMq-_XySam0x3wJLD5XyYX4OiSY",
	authDomain:
		process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ??
		"advance-web-e9f73.firebaseapp.com",
	projectId:
		process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "advance-web-e9f73",
	storageBucket:
		process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ??
		"advance-web-e9f73.appspot.com",
	messagingSenderId:
		process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "406929641485",
	appId:
		process.env.REACT_APP_FIREBASE_APP_ID ??
		"1:406929641485:web:57b870dfc520a287fe0544",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

const ensureUserDocument = async (user: User, authProvider: string) => {
	const existingUserSnapshot = await getDocs(
		query(collection(db, "users"), where("uid", "==", user.uid))
	);

	if (existingUserSnapshot.empty) {
		await addDoc(collection(db, "users"), {
			uid: user.uid,
			name: user.displayName,
			authProvider,
			email: user.email,
		});
	}
};

export const signInWithGoogle = async (): Promise<UserCredential> => {
	const credential = await signInWithPopup(auth, googleProvider);
	await ensureUserDocument(credential.user, "google");
	return credential;
};

export const logInWithEmailAndPassword = (
	email: string,
	password: string
): Promise<UserCredential> => {
	return signInWithEmailAndPassword(auth, email, password);
};

export const registerWithEmailAndPassword = async (
	email: string,
	password: string
): Promise<UserCredential> => {
	const credential = await createUserWithEmailAndPassword(
		auth,
		email,
		password
	);
	await addDoc(collection(db, "users"), {
		uid: credential.user.uid,
		authProvider: "local",
		email,
	});
	return credential;
};

export const sendPasswordReset = (email: string): Promise<void> => {
	return sendPasswordResetEmail(auth, email);
};

export const logout = (): Promise<void> => {
	return signOut(auth);
};
